import { lazy } from 'react';

export const AddBankCard = lazy(() => import('./AddBankCard.component'));
